import React, { FunctionComponent } from "react";

interface ConfigPageContainerProps {
  title: string;
  className?: string;
}

const ConfigPageContainer: FunctionComponent<ConfigPageContainerProps> = ({
  title,
  className,
  children,
  ...props
}) => (
  <div className={`config-page ${className || ""}`} {...props}>
    <h2 className="config-page__title">{title}</h2>
    {children}
  </div>
);

export default ConfigPageContainer;
